import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="relative w-full bg-cream px-4 py-10 sm:px-6 sm:py-12" data-id="element-189" data-mp="1l9fsdcfv0m8f">
      <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-190" data-mp="1gal0zm3ttpcp" />
      <span aria-hidden="true" className="gold-glitter-extra" data-id="element-191" data-mp="2dz4xa0vox6fb" />
      <div className="relative z-10 mx-auto max-w-3xl" data-id="element-192" data-mp="290tlhklu4lug">
        <div className="text-center" data-id="element-193" data-mp="2924rzs6o07p9">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-hot-500" data-id="element-194" data-mp="24209jwm752we">
            Häufige Fragen
          </span>
          <h2 className="font-heading mt-4 text-3xl font-extrabold uppercase leading-tight text-neutral-900 sm:text-4xl" data-id="element-195" data-mp="1z2dudhmt5cky">
            Alles, was du wissen musst
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm text-neutral-600 sm:text-base" data-id="element-196" data-mp="nnqtdps3ykgn">
            Deine Frage ist nicht dabei? Schreib uns – wir antworten persönlich.
          </p>
        </div>

        <ul className="mt-8 space-y-2.5" data-id="element-197" data-mp="uhkc7mt135zj">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <motion.li key={faq.question} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.3,
            delay: i * 0.05
          }} className="overflow-hidden rounded-2xl border border-hot-100 shadow-xl" data-id="element-198" data-mp="fjibdkddsylz" data-mpi={i}>
                <h3 data-id="element-199" data-mp="3t07so3wrpg48">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="font-heading flex w-full items-center justify-between gap-4 bg-hot-50 px-5 py-4 text-left text-sm font-semibold text-neutral-900 transition-colors hover:bg-hot-100 sm:text-base" data-id="element-200" data-mp="3swk0b8326zr3">
                    {faq.question}
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center gold-icon-shiny rounded-full text-white" data-id="element-201" data-mp="1potfgou57b7e">
                      {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-202" data-mp="1fsztkeuja5cy" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-203" data-mp="2denqd0uwipp0" />}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-204" data-mp="23h9cn90d4f0e">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeOut'
              }} data-id="element-205" data-mp="1zfxu1nfwou1p">
                      <p className="px-5 py-4 text-sm leading-relaxed text-neutral-600" data-id="element-206" data-mp="2zpfbugt5bys5">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.li>;
        })}
        </ul>
      </div>
    </section>;
}